import Vue from 'vue'
import sanityMixin from '../mixins/sanity'

Vue.mixin(sanityMixin)
